var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DOMReady from "../utils/DOMReady";
import { delay } from "../utils/general";
var MOBILE_MENU_BUTTON_ID = "mobile-menu-button";
var MOBILE_MENU_ID = "mobile-menu";
var MENU_ITEM_HAS_CHILDREN_CLASS = "menu-item-has-children";
var SUBMENU_ACTIVE_CLASS = "submenu-active";
var OFFSET = 20; // Minimum distance from the edge of the screen
var HEADER_OFFSET = 140; // Header height for scroll offset
function adjustSubmenuPosition(submenu) {
    var rect = submenu.getBoundingClientRect();
    var viewportWidth = window.innerWidth;
    if (rect.right > viewportWidth - OFFSET) {
        submenu.style.left = "-".concat(rect.right - viewportWidth + OFFSET, "px");
    }
    else if (rect.left < OFFSET) {
        submenu.style.left = "".concat(OFFSET - rect.left, "px");
    }
}
// Update active menu item based on scroll position
function updateActiveMenuItem() {
    var sections = document.querySelectorAll("section[id]");
    var navLinks = document.querySelectorAll(".nav-menu__link, .mobile-nav__link");
    var currentSection = "";
    sections.forEach(function (section) {
        var sectionTop = section.offsetTop - HEADER_OFFSET - 50;
        var sectionHeight = section.offsetHeight;
        if (window.scrollY >= sectionTop &&
            window.scrollY < sectionTop + sectionHeight) {
            currentSection = section.getAttribute("id") || "";
        }
    });
    navLinks.forEach(function (link) {
        link.classList.remove("active");
        var href = link.getAttribute("href");
        if (href === "#".concat(currentSection)) {
            link.classList.add("active");
        }
    });
}
// Smooth scroll to anchor with offset
function scrollToAnchor(e, anchor) {
    e.preventDefault();
    var targetId = anchor.replace("#", "");
    var targetSection = document.getElementById(targetId);
    if (targetSection) {
        var targetPosition = targetSection.offsetTop - HEADER_OFFSET;
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
        // Update URL hash without jumping
        history.pushState(null, "", anchor);
    }
}
DOMReady(function () {
    var mobileMenuButton = document.getElementById(MOBILE_MENU_BUTTON_ID);
    var mobileMenu = document.getElementById(MOBILE_MENU_ID);
    // Mobile menu toggle
    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener("click", function () {
            mobileMenu.classList.toggle("hidden");
        });
    }
    // Submenu handling for dropdown menus
    var menuItems = document.querySelectorAll(".".concat(MENU_ITEM_HAS_CHILDREN_CLASS));
    menuItems.forEach(function (item) {
        var timeout;
        item.addEventListener("mouseenter", function () {
            clearTimeout(timeout);
            item.classList.add(SUBMENU_ACTIVE_CLASS);
            var submenu = item.querySelector("ul");
            if (submenu instanceof HTMLElement) {
                adjustSubmenuPosition(submenu);
            }
        });
        item.addEventListener("mouseleave", function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(300)];
                    case 1:
                        _a.sent();
                        item.classList.remove(SUBMENU_ACTIVE_CLASS);
                        return [2 /*return*/];
                }
            });
        }); });
    });
    // Smooth scroll for anchor links
    var anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(function (link) {
        link.addEventListener("click", function (e) {
            var anchor = link.getAttribute("href");
            if (anchor && anchor !== "#") {
                scrollToAnchor(e, anchor);
                // Close mobile menu after clicking
                if (mobileMenu && !mobileMenu.classList.contains("hidden")) {
                    mobileMenu.classList.add("hidden");
                }
            }
        });
    });
    // Update active menu item on scroll
    window.addEventListener("scroll", updateActiveMenuItem, { passive: true });
    // Initial check for active menu item
    updateActiveMenuItem();
    // Check for hash in URL on page load
    if (window.location.hash) {
        setTimeout(function () {
            var anchor = window.location.hash;
            var fakeEvent = {
                preventDefault: function () {
                    return;
                },
            };
            scrollToAnchor(fakeEvent, anchor);
        }, 100);
    }
});
